export const loTrinh = {
  banDo: {
    title: '配送地图',
    subtitle: '按配送期限待配送的订单',
    filter: {
      hanGiao: '配送期限',
      hanGiaoTu: '从',
      hanGiaoDen: '至',
      loaiGiao: '配送方式',
      trangThai: '订单状态',
      search: '发票、客户、电话…',
      xem: '查看',
      loaiGiaoTatCa: '全部',
      loaiGiaoTuGiao: '自有配送员',
      loaiGiaoHang: '物流公司',
      tatCaTrangThai: '全部状态',
      timKiem: '搜索',
      hinhThucTrangThai: '配送方式与状态',
      sapXep: '排序',
      sapXepTheo: '排序依据',
      khoVatLy: '实体仓',
      khoVatLyTatCa: '全部实体仓',
      khoVatLyEmpty: '暂无实体仓',
    },
    sapXep: {
      hanGiaoTang: '期限最早',
      hanGiaoGiam: '期限最晚',
      canGiam: '最重',
      khoiGiam: '体积最大',
      kienGiam: '件数最多',
      maDon: '发票编号',
      khachHang: '客户名称 (A–Z)',
    },
    preset: {
      den3hToi: '未来 3 小时内',
      homNay: '今天',
      ngayMai: '明天',
      homNayVaMai: '今天和明天',
      tuyChon: '自定义',
    },
    nhomTrangThai: {
      moi: '新建',
      xuLyKho: '仓库处理中',
      dieuPhoi: '待调度 / 调度中',
      giaoHang: '待配送 / 配送中',
      giaoLai: '失败 / 重新配送',
    },
    thamSo: {
      title: '当前筛选',
      hanGiao: '期限',
      loaiGiao: '方式',
      trangThai: '状态',
      search: '关键词',
      mucHan: '紧急程度',
      ketQua: '{don} 个订单 · {diem} 个站点',
    },
    donVi: {
      kg: 'kg',
      kien: '件',
      m3: 'm³',
      don: '单',
    },
    nhan: {
      an: '圆点',
      anMo: '仅显示圆点 — 悬停查看标签',
      gon: '时间',
      gonMo: '精简：期限',
      diaChi: '地址',
      diaChiMo: '客户 + 地址',
      dayDu: '完整',
      dayDuMo: '期限 + 客户 + 地址 + 重量 / 件数 / 体积',
    },
    veBanDau: '重置视图',
    xoayBanDo: '旋转地图 90°（当前 {n}°）',
    nen: {
      sang: '浅色地图',
      chiTiet: '详细地图',
    },
    tongHop: {
      soDon: '{n} 个订单',
      soDiem: '{n} 个站点',
      tongKg: '{n} kg',
      tongM3: '{n} m³',
      tongKien: '{n} 件',
      tongCod: '代收 {n}',
      nhanSoDon: '订单',
      nhanSoDiem: '站点',
      nhanTongKg: '总重量 (kg)',
      nhanTongKien: '件数',
      nhanTongM3: '总体积 (m³)',
      nhanTongCod: '代收总额',
      thieuToaDo: '{n} 个订单缺少坐标',
      biCatBot: '仅显示前 {n} 个订单 — 请缩小时间范围',
    },
    chuGiai: {
      title: '期限',
      tatCa: '全部',
      quaHan: '已逾期',
      trong2h: '2 小时内',
      homNay: '今天稍后',
      sauHomNay: '明天起',
      kho: '仓库',
    },
    list: {
      empty: '该期限范围内没有订单',
      thieuToaDo: '无坐标',
      hangVanChuyen: '物流公司',
    },
    don: {
      khachHang: '客户',
      nguoiNhan: '收货人',
      diaChi: '地址',
      hanGiao: '期限',
      khungGio: '收货时段',
      canKhoiKien: '重量 / 体积 / 件数',
      kichThuoc: '包裹尺寸',
      tongTien: '总金额',
      cod: '代收',
      dichVu: '服务',
      doiTac: '配送方',
      uuTien: '优先级',
      hangHoa: '商品',
      ghiChu: '备注',
      xemChiTiet: '查看订单',
      themMatHang: '另有 {n} 件商品',
      soDonTaiDiem: '该站点 {n} 个订单',
      quaHanPhut: '逾期 {n}',
    },
    tab: {
      don: '订单',
      loTrinh: '路线建议',
    },
    goiY: {
      khoXuatPhat: '出发仓库',
      gioXuatPhat: '出发时间',
      veKho: '返回仓库',
      xe: '车辆',
      quanLyXe: '管理车辆',
      chuaCoXe: '暂无车辆 — 点击“管理车辆”添加',
      chonTatCa: '全选',
      boChon: '取消选择',
      soXe: '{n} 辆车',
      caLam: '班次',
      suaThongSo: '编辑',
      thuGon: '收起',
      nut: '建议路线（{n} 个订单）',
      dangTinh: '正在计算路线…',
      boQuaHang: '跳过 {n} 个由物流公司配送的订单',
      khongCoDon: '当前筛选中没有自配送订单',
      phuongAn: '方案',
      mucTieu: {
        RE: '成本最低',
        IT_XE: '车辆最少',
        NHANH: '最快',
        KHU_VUC: '按区域',
        CAN_BANG: '均衡',
        TU_CHINH: '已手动调整',
      },
      cungKetQua: '与 {n} 相同',
      canhBaoPa: '{n} 趟需检查',
      canhBao: {
        QUA_TAI_KG: '超重',
        QUA_TAI_M3: '超体积',
        VUOT_SO_DIEM: '站点过多',
        VUOT_CA: '超过下班时间',
      },
      chinh: {
        doiXe: '为此趟更换车辆',
        doiSang: '换成车辆',
        doiCho: '与其当前趟次互换',
        chuyenDon: '将订单 {n} 移至',
        chuyenMoi: '新趟次',
        boRa: '从趟次中移除',
        themVao: '将订单 {n} 加入车辆',
        meo: '点击订单编号可移动 / 移除',
        hoanTac: '撤销',
        dangTinhLai: '正在重新计算…',
      },
      kpi: {
        km: '总公里数',
        thoiGian: '总时间',
        chiPhi: '预计成本',
        soXe: '车辆',
        donTre: '迟到订单',
        khongXep: '未分配',
      },
      chuyen: {
        xuatPhat: '出发 {n}',
        ve: '返回 {n}',
        ketThuc: '结束 {n}',
        tai: '装载',
        vuotCa: '超出班次',
        diem: '{n} 个站点',
        xemTrenBanDo: '仅显示此趟',
        hienTatCa: '显示全部趟次',
      },
      tre: '迟到',
      khongXepTitle: '未分配的订单',
      lyDo: {
        THIEU_TOA_DO: '缺少坐标',
        VUOT_TAI: '超出最大车辆载重',
        KHONG_DU_XE: '车辆 / 班次时间不足',
        BO_RA: '未分配',
      },
      thongKe: '距离：缓存 {cache} 对，新计算 {moi} 对（{req} 次请求），估算 {uoc} 对 · {ms} ms',
      nguon: {
        OSRM: '真实路网 (OSRM)',
        UOC_LUONG: '直线估算 — 未启用 OSRM',
        KET_HOP: '部分估算 — OSRM 缺少数据',
      },
      solver: {
        VROOM: 'VROOM',
        NOI_BO: '内置求解器',
      },
      lamMoi: '重新计算',
      dong: '关闭结果',
      phut: '{n} 分钟',
      gioPhut: '{h} 小时 {m} 分钟',
    },
    xe: {
      title: '配送车辆',
      them: '添加车辆',
      sua: '编辑车辆',
      xoa: '删除车辆',
      xacNhanXoa: '删除车辆“{n}”？',
      daLuu: '车辆已保存',
      daXoa: '车辆已删除',
      ten: '名称',
      bienSo: '车牌号',
      loaiXe: '车型',
      taiTrongKg: '载重 (kg)',
      theTichM3: '货厢体积 (m³)',
      theTichMo: '留空 = 不限',
      soDiemToiDa: '每趟最多站点',
      gioBatDau: '班次开始',
      gioKetThuc: '返回时间不晚于',
      phiCoDinh: '每趟固定成本',
      phiMoiKm: '每公里成本',
      phiMoiGio: '每小时成本',
      phiMo: '用于比较方案 — 留空则使用默认值 5,000/km、50,000/小时',
      kho: '默认仓库',
      khoTheoForm: '使用建议时所选的仓库',
      tenTaiXe: '司机',
      dienThoaiTaiXe: '司机电话',
      ghiChu: '备注',
      dangHoatDong: '启用',
      ngungHoatDong: '停用',
      trong: '暂无车辆',
      luu: '保存',
      huy: '取消',
      batBuoc: '必填',
    },
  },
}
